'use client';

import type { TDynamicData } from '@eliadmin/core/src/types/dynamic-data';
import type { ContactPriceFormValues } from './contact-price-schema';
import type { UseFormReturn } from 'react-hook-form';

import { FormHeader } from './form-header';
import { FormContent } from './form-content';
import { Field } from '@eliadmin/core/src/components/form/field';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { useLocaleStore } from '@eliadmin/core/src/stores/locale-store';

interface FirstStepProps {
  title: string;
  step: number;
  interests: TDynamicData[];
  form: UseFormReturn<ContactPriceFormValues>;
}

export function FirstStep({ title, step, interests, form }: FirstStepProps) {
  const locale = useLocaleStore(s => s.currentLocale);

  const { t } = useTranslations();

  return (
    <>
      <div className="flex w-full flex-col items-start justify-start gap-8">
        <FormHeader step={step} title={title} />
        <FormContent>
          <Field
            type="select"
            name="custom.text1416"
            label={t('text3576')}
            placeholder={t('text3577')}
            options={interests.map(interest => ({ label: interest.name, value: interest.name }))}
            className={{ wrapper: 'h-[85px] w-full' }}
            control={form.control}
          />
          <Field
            type="text"
            name="custom.text1329"
            label={t('text3578')}
            placeholder={t('text3579')}
            className={{ wrapper: 'h-[85px] w-full' }}
            control={form.control}
          />
          <Field
            type="text"
            name="custom.text147"
            label={t('text3580')}
            placeholder={locale === 'sk' ? 'DD.MM.RRRR' : 'TT.MM.JJJJ'}
            className={{ wrapper: 'h-[85px] w-full' }}
            control={form.control}
          />
        </FormContent>
      </div>
    </>
  );
}
